// Central place to define the feature flag names used in Unleash and config
export const SESSION_END_ORDER_ACTION_CHANGES_FLAG_NAME =
  'session_end_order_action_changes';
export const TIMER_RESET_ON_CART_UPDATE_FLAG_NAME =
  'timer_reset_on_cart_update';
export const SUPPRESS_UPSELL_FLAG_NAME = 'suppress_upsell';
export const DO_NOT_UPSELL_IN_EXPRESS_MODE_FLAG_NAME =
  'do_not_upsell_in_express_mode';
export const UNRESOLVED_ITEMS_FLAG_NAME = 'unresolved_items';
export const HITL_3_0_FLAG_NAME = 'hitl_3_0';
export const AGENT_CART_FLAG_NAME = 'agent_cart';
export const HITL_EXPRESS_TIMER_FLAG_NAME = 'hitl_express_timer';
// Carries a variant whose payload value is the agent response-time SLA in
// seconds (Pulse "Response time" tile). Falls back to the default below when the
// flag/variant is absent, so behaviour matches the previous env-var default.
export const AGENT_RESPONSE_TIME_FLAG_NAME = 'agent_response_time';
export const DEFAULT_AGENT_RESPONSE_TIME_LIMIT_SECONDS = 6;
export const MENU_MODULE_ERROR_UI_FLAG_NAME = 'menu_module_error_ui';
// The promoted-ASR badge requires BOTH flags below: the AI-side flag says the
// secondary ASR engine is running at all; the HITL-side flag says the HITL UI
// should surface it. They are ANDed in useUnleash.hooks, so the badge can be
// rolled out (or killed) on the HITL side without touching the AI's flag.
export const SECONDARY_ASR_ENABLED_FLAG_NAME = 'secondary_asr_enabled';
export const HITL_SECONDARY_ASR_ENABLED_FLAG_NAME =
  'hitl_secondary_asr_enabled';
